import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SchemasService {
  private readonly document = inject(DOCUMENT);

  parseJsonSafely(jsonString: string) {
    try {
      return JSON.parse(jsonString);
    } catch (error: any) {
      console.error(`Error al validar SCHEMA MARKUP: ${error.message}`);
      return {};
    }
  }

  addLdJsonScript(jsonData: any): void {
    if (this.document.querySelector('script[type="application/ld+json"]')) {
      return;
    }

    const script = this.document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonData);

    this.document.head.appendChild(script);
  }

  removeLdJsonScript(): void {
    const existingScript = this.document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }
  }
}
